import * as React from "react";
import { RowTitleButton } from "common/components";
import { useFetchAsset } from "security-app/hooks/useAssetsAPI";
import useAssetPanel from "./hooks/useAssetPanel";
const AssetNameCell = ({ asset }) => {
  const { openAssetDetails } = useAssetPanel();
  const fetchFullAsset = useFetchAsset();
  const onClick = async () => {
    const fullAsset = await fetchFullAsset(asset.id);
    if (fullAsset) {
      openAssetDetails(fullAsset);
    }
  };
  return /* @__PURE__ */ React.createElement(RowTitleButton, { onClick }, asset.name);
};
export default AssetNameCell;
